import { useCallback, useRef, useState, type FormEvent } from 'preact/compat';

import { AppSettings } from '@/constants/app-settings';

type Props = {
  organizationId: string;
};

export function RegisterForm({ organizationId }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const emailInputRef = useRef<HTMLInputElement>(null);

  const onRegister = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      setIsLoading(true);

      const response = await fetch(
        `${AppSettings.apiUrl}/chats/auth/register`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: emailInputRef.current?.value,
            organizationId,
          }),
        },
      );

      if (!response.ok) {
        // TODO: Handle error and show error message to user
        console.error('Failed to register');
        setIsLoading(false);

        return;
      }

      setIsLoading(false);
      setIsDone(true);
    },
    [organizationId],
  );

  return (
    <div className='flex w-full justify-center'>
      {!isDone && (
        <form className='w-full' onSubmit={onRegister}>
          <div className='flex gap-3.5'>
            <div className='w-full rounded-2xl border-[#e4e4e7] bg-white'>
              <div className='ml-px mt-px flex size-[calc(100%-2px)] gap-3.5 overflow-hidden rounded-[12px] bg-white'>
                <input
                  ref={emailInputRef}
                  data-cta='web-input-register-form-email-input'
                  className='grow px-[16px] py-[8px] text-[14px] leading-[20px] text-[#71717a] outline-none'
                  type='email'
                  name='email'
                  placeholder='Váš email'
                  required
                  disabled={isLoading}
                />
                <button
                  data-cta='web-input-register-form-submit-button'
                  type='submit'
                  className='my-px mr-px h-[calc(100%-2px)] shrink-0 self-end rounded-[13px] bg-[#9c70ff] px-3.5 text-[14px] text-white transition hover:bg-[#8a58ff]'
                  disabled={isLoading}
                >
                  Ověřit e-mail
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
      {isDone && (
        <span className='text-[14px] leading-[24px] text-[#1a1a1a]'>
          Koukněte do emailu a potvrďte registraci
        </span>
      )}
    </div>
  );
}
